import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';
import { useTimeTableApi } from '../../../contexts/timeTableContext'
import CheckBoxField from '../../shared/checkBoxField';

const InvoicingEntry = ({ tdStyle, entry }) => {
  const { updateTimeEntry, toggleState, updateState } = useTimeTableApi()
  const onClick = (timeEntry) => {
    toggleState("rndModal"),
    updateState("selectedTimeEntry", timeEntry)
  }

  const cellClass = useMemo(() => {
    if (isEmpty(entry.consumable_entries)) {
      return tdStyle
    }
    const updatedTdStyle = tdStyle.replace('bg-white', '').trim();
    return `${updatedTdStyle} bg-gray-300 `
  }, [tdStyle, entry])

  const isRndChecked = !!entry.rnd_entry?.description?.trim();

  return (
    <td className={cellClass}>
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <CheckBoxField
            checked={entry.non_billable}
            setChecked={(value) => updateTimeEntry(entry, { non_billable: value })}
          />
          <span className="whitespace-nowrap"><strong>Non-Billable</strong></span>
        </div>
        <div className="flex items-center gap-2">
          <CheckBoxField
            checked={entry.approved_for_invoicing}
            setChecked={(value) => updateTimeEntry(entry, { approved_for_invoicing: value })}
          />
          <span className="whitespace-nowrap"><strong>Approved for Invoicing</strong></span>
        </div>
        <div className="flex items-center gap-2">
          <CheckBoxField
            checked={entry.captured_on_field_ticket}
            setChecked={(value) => updateTimeEntry(entry, { captured_on_field_ticket: value })}
          />
          <span className="whitespace-nowrap"><strong>Captured on Field Ticket</strong></span>
        </div>

        <div className="flex items-center gap-2">
          <CheckBoxField
            checked={isRndChecked}
            setChecked={() => onClick(entry)}
          />
          <span className="whitespace-nowrap"><strong>R&D Entry</strong></span>
        </div>
      </div>
    </td >
  )
}

export default InvoicingEntry
